import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-dominant text-white mt-12">
      <div className="container mx-auto px-4 py-8">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="flex items-center gap-3 mb-4 md:mb-0">
            <i className="fas fa-shield-alt text-secondary text-2xl"></i>
            <span className="text-xl font-bold">SafeDash</span>
          </div>
          
          <div className="text-center md:text-right">
            <p className="text-gray-300">
              Decentralized DAO Dashboard • Pinned to IPFS • Verified via ENS
            </p>
            <p className="text-gray-400 text-sm mt-1">
              Built with React + Vite • Deployed via PinMe
            </p>
          </div>
        </div>
        
        <div className="border-t border-gray-700 mt-6 pt-6 text-center text-gray-400">
          <p>&copy; 2025 SafeDash. All rights reserved. Decentralized and secure.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;